import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import seo from "../seo/config.mjs";
import seoDocument from "../seo/document.mjs";

export default function PageSeo() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    seoDocument.applySeo(seo.getPageMeta(pathname));
  }, [pathname]);
  return null;
}
